import React from 'react';
import filter from '../../assets/home/filter.png';
import search from '../../assets/home/search.png';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';
import { InputAdornment, TextField, IconButton } from '@mui/material';

const useStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: '#D8E1DB',
      borderRadius: '100px',
      boxShadow: 'inset 1px 1px 1px rgba(0, 0, 0, 0.2)',
      backgroundColor: 'transparent', // Changed from 'white' to 'transparent'
    },
    '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1E3625',
      backgroundColor: 'transparent', // Keep transparent on hover
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3C6B49',
      backgroundColor: 'transparent', // Keep transparent when focused
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px',
      color: '#1E3625',
      zIndex: 20,
      backgroundColor: 'transparent', // Make input background transparent
      '&::placeholder': {
        zIndex: 20,
        fontSize: 'small',
        fontFamily: 'Poppins-Regular',
        '@media(max-width: 2000px)': {
          fontSize: 'medium',
        },
      },
    },
    '&:hover .MuiOutlinedInput-input': {
      color: '#1E3625',
      backgroundColor: 'transparent', // Keep transparent on hover
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input': {
      color: '#1E3625',
      backgroundColor: 'transparent', // Keep transparent when focused
    },
    '& .MuiInputLabel-outlined': {
      color: 'green',
    },
    '&:hover .MuiInputLabel-outlined': {
      color: '#1E3625',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#1E3625',
    },
  },
});

const SearchInput = ({ isEndAdornment, state, handleClick, handleChange, handleSearch, handleClear }) => {
  const classes = useStyles();
  const handleClickOnEnter = (e) => {
    if (e.key === 'Enter') {
      handleSearch("search");
    }
  };

  const handleClearSearch = () => {
    handleChange('query', '');
    if (handleClear) {
      handleClear(); // Call the clear handler passed from parent
    }
  };
  return (
    <>
      <TextField
        sx={{ width: '100%' }}
        className={classes.root}
        onChange={(e) => handleChange('query', e.target.value)}
        onKeyPress={handleClickOnEnter}
        value={state?.query}
        InputProps={{
          startAdornment: (
            <InputAdornment style={{ zIndex: 20 }} position="start">
              <SearchIcon sx={{ color: '#283c2e', fill: '#283c2e' }} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment style={{ zIndex: 20 }} position="end">
              {state?.query && (
                <IconButton
                  size="small"
                  onClick={handleClearSearch}
                  style={{ marginRight: isEndAdornment ? '8px' : '0px' }}
                >
                  <CloseIcon sx={{ color: '#283c2e', fontSize: '18px' }} />
                </IconButton>
              )}
              {isEndAdornment && (
                <img 
                  src={filter} 
                  alt="filter" 
                  style={{ cursor: 'pointer' }} 
                  onClick={handleClick}
                />
              )}
            </InputAdornment>
          ),
        }}
        placeholder={'Search'}
      />
    </>
  );
};

export default SearchInput;
